import { PriceRange } from "@adobe-commerce/elsie/components";
import { Product } from "@/plp/data/models/product";

export const ComplexProductPrice = ({ product }: { product: Product }) => {
  let currency =
    product.priceRange?.minimum?.regular?.amount?.currency ?? "USD";

  if (!Intl.supportedValuesOf("currency").includes(currency)) {
    currency = "USD";
  }

  const minFinal = product.priceRange?.minimum?.final.amount.value;
  const minRegular = product.priceRange?.minimum?.regular.amount.value;
  const maxFinal = product.priceRange?.maximum?.final.amount.value;
  const maxRegular = product.priceRange?.maximum?.regular.amount.value;

  const hasSpecial = minFinal < minRegular || maxFinal < maxRegular;

  if (!hasSpecial) {
    return (
      <PriceRange
        display="from to"
        minimumAmount={minRegular}
        maximumAmount={maxRegular}
        currency={currency}
      />
    );
  }

  return (
    <div class="product-price">
      <span class="regular-price-normal">
        <PriceRange
          display="from to"
          minimumAmount={minFinal}
          maximumAmount={maxFinal}
          currency={currency}
        />
      </span>

      <span class="special-price-crossed">
        <PriceRange
          display="from to"
          minimumAmount={minRegular}
          maximumAmount={maxRegular}
          currency={currency}
        />
      </span>
    </div>
  );
};